import React from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { sendRequest } from '../helpers/global';

import DateInput from './input/DateInput';

import '../sass/components/ReportView.scss';

class ReportView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().endOf('month').format('YYYY-MM-DD'),
      data: null,
      payments: [],
      chunkSize: 1,
    }
  }

  componentDidMount = () => {
    this.requestUsers();
  }

  requestUsers = () => {
    sendRequest({
      method: 'users',
      type: 'GET',
      success: (data) => {
        this.setState({
          users: (data?.objects || [])
            .filter(user => user.active)
            .sort((a, b) => a.id - b.id)
        });
      },
      error: (data) => {
      }
    });
  }

  requestStats = () => {
    const { from, to } = this.state;
    sendRequest({
      method: 'reports',
      type: 'GET',
      data: {
        from, to,
      },
      success: (data) => {
        this.setState({data});
      },
      error: (data) => {
      }
    });
  }

  requestPayments = () => {
    const { from, to } = this.state;
    sendRequest({
      method: 'payments',
      type: 'GET',
      data: {
        from, to,
      },
      success: (data) => {
        this.setState({payments: data?.objects || []});
      },
      error: (data) => {
      }
    });
  }

  blockOrders = () => {
    sendRequest({
      method: 'menu/close',
      type: 'POST',
      success: (data) => {
      },
      error: (data) => {
      }
    });
  }

  setThisWeek = () => {
    this.setState({
      from: moment().startOf('week').format('YYYY-MM-DD'),
      to: moment().endOf('week').format('YYYY-MM-DD'),
    });
  }

  setNextWeek = () => {
    this.setState({
      from: moment().add(1, 'week').startOf('week').format('YYYY-MM-DD'),
      to: moment().add(1, 'week').endOf('week').format('YYYY-MM-DD'),
    });
  }

  setThisMonth = () => {
    this.setState({
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().endOf('month').format('YYYY-MM-DD'),
    });
  }

  setLastMonth = () => {
    this.setState({
      from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    });
  }

  groupItems = (items) => {
    return items.map((i, index) =>
      <i key={index}>
        {i.position}{i.qnt > 1 ? `x${i.qnt}` : ''}{index < items.length - 1 ? ',\xa0' : ''}
      </i>
    );
  }

  getItemsAmount = (items) => {
    return items.reduce((res, cur) => res + cur.amount, 0)
  }

  getDayDataGrouppedByUsers = (day) => {
    const grouppedByUsers = {};
    day.items_by_users.forEach(i => {
      if (!grouppedByUsers[i.user.id]) {
        grouppedByUsers[i.user.id] = {};
        grouppedByUsers[i.user.id].name = i.user.name;
        grouppedByUsers[i.user.id].items = [];
      }
      grouppedByUsers[i.user.id].items.push(...i.items);
    });
    return grouppedByUsers;
  }

  renderDailySums = (data) => {
    return (
      <div className='dataReport'>
        {data.map(this.renderDetailedCostsDay)}
      </div>
    )
  }

  renderDetailedCostsDay = (day) => {
    const grouppedByUsers = this.getDayDataGrouppedByUsers(day);
    return (
      <div
        key={day.date}
        className='reportDay'
      >
        <div className='dayPrimary'>
          <div className='rowTitle'>{moment(day.date).format('ddd DD.MM')}: </div>
          <div className='rowContent'>{this.groupItems(day.items)}</div>
          <div className='rowSummary'>{day.amount || 0} р.</div>
        </div>
        {Object.keys(grouppedByUsers).map(userId => 
          <div key={userId} className='daySecondary'>
            <div className='rowTitle'>{grouppedByUsers[userId].name}</div>
            <div className='rowContent'>{this.groupItems(grouppedByUsers[userId].items)}</div>
            <div className='rowSummary'>{this.getItemsAmount(grouppedByUsers[userId].items)} р.</div>
          </div>
        )}
      </div>
    )
  }

  setChunkSize = (e) => {
    this.setState({
      chunkSize: Math.min(5, Math.max(1, Number(e.target.value))),
    });
  }

  renderDailyMeals = (data) => {
    const size = this.state.chunkSize;
    const chunks = data.flatMap((_, i, a) => i % size ? [] : [a.slice(i, i + size)]);
    return chunks.map((chunk, index) =>
      <div
        key={index}
        className='page'
      >
        {chunk.map(this.renderDayMeals)}
      </div>
    );
  }

  renderDayMeals = (day) => {
    const grouppedByUsers = this.getDayDataGrouppedByUsers(day);
    return (
      <div
        key={day.date}
        className='mealsTable'
      >
        <table>
          <thead>
            <tr>
              <th width='140px'/>
              <th width='auto'/>
            </tr>
            <tr>
              <th colSpan='2'>
                <b>{moment(day.date).format('ddd DD.MM')}</b>
                <span>({day.items.length} коробок)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(grouppedByUsers).map(userId => 
              <tr key={userId}>
                <td>{grouppedByUsers[userId].name}</td>
                <td>
                  {grouppedByUsers[userId].items.map(item =>
                    <i key={item.position}>
                      {item.qnt} x {item.name || 'NAME?'}
                    </i>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }

  renderMotorinExport = (data) => {
    const totalUsers = {};
    data.forEach(day => {
      day.items_by_users.forEach(i => {
        if (!totalUsers[i.user.id]) {
          totalUsers[i.user.id] = i.user;
        }
      })
    });
    return (
      <div className='dataReport'>
        <div className='reportDay'>
          <div className='dayPrimary'>
            <div className='rowContent'>Всего заказали чел. - {Object.keys(totalUsers).length}:</div>
          </div>
          <div className='daySecondary'>
            <div className='rowContent'>
              {Object.keys(totalUsers).map(userId => totalUsers[userId].name).join(', ')}
            </div>
          </div>
        </div>
        {data.map(day =>
          <div
            key={day.date}
            className='reportDay'
          >
            <div className='dayPrimary'>
              <div className='rowContent inline'>
                {moment(day.date).format('DD.MM')}:&nbsp;
                {this.groupItems(day.items)}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderSumarryCosts = (data, payments) => {
    const users = this.state.users;
    const userData = {};
    users.forEach(user => {
      userData[user.id] = {
        amount: 0,
        excess: 0,
        compensation: 0,
        total: 0,
      };
    });
    
    data.forEach(day => {
      day.items_by_users.forEach(i => {
        userData[i.user.id].amount += this.getItemsAmount(i.items);
        userData[i.user.id].excess = Math.max(userData[i.user.id].amount, 10000) - 10000;
      });
    });

    payments.forEach(payment => {
      userData[payment.user.id].compensation += (Number(payment.amount) || 0) / 2;
      userData[payment.user.id].total = userData[payment.user.id].excess - userData[payment.user.id].compensation;
    });
    
    const summary = {
      amount: 0,
      excess: 0,
      compensation: 0,
      total: 0,
    };
    users.forEach(user => {
      summary.amount += userData[user.id].amount;
      summary.excess += userData[user.id].excess;
      summary.compensation += userData[user.id].compensation;
      summary.total += userData[user.id].total;
    });
    
    return (
      <table className='reportTable'>
        <thead>
          <tr>
            <th width='120px'>Сотрудник</th>
            <th width='80px'>Всего еда</th>
            <th width='80px'>Превышение квоты</th>
            <th width='80px'>Возмещение ИИ</th>
            <th width='80px'>Итого</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => 
            <tr key={user.id} className='reportTableItem'>
              <td>{user.name}</td>
              <td>{userData[user.id].amount}</td>
              <td>{userData[user.id].excess}</td>
              <td>{userData[user.id].compensation}</td>
              <td>{userData[user.id].total}</td>
            </tr>
          )}
          <tr className='reportTableTotal'>
            <td>Сумма</td>
            <td>{summary.amount}</td>
            <td>{summary.excess}</td>
            <td>{summary.compensation}</td>
            <td>{summary.total}</td>
          </tr>
        </tbody>
      </table>
   )
  }

  renderDetailedDayPrice = (item) => {
    const totalPrice = item.items.reduce((acc, day) => acc + day.amount, 0);
    return (
      <React.Fragment key={`${item.date}`}>
        <tr key={`${item.date}-date`} colSpan={3} className='reportTableDate'>
          <td colSpan={4}>{moment(item.date).format('DD.MM.YYYY')}</td>
        </tr>
        {item.items.map((day, index) =>
          <tr key={`${item.date}-${index}`} className='reportTableItem'>
            <td>{day.name}</td>
            <td>{day.amount / day.qnt}</td>
            <td>{day.qnt}</td>
            <td>{day.amount}</td>
          </tr>
        )}
        <tr key={`${item.date}-price`} colSpan={3} className='reportTableDayTotal'>
          <td colSpan={3}>Всего за {moment(item.date).format('DD.MM.YYYY')}:</td>
          <td>{totalPrice}</td>
        </tr>
      </React.Fragment>
    )
  }

  renderDetailedPrice = (data) => {
    const totalPrice = data.reduce((acc, item) => acc +
      item.items.reduce((acc, day) => acc + day.amount, 0)
    , 0);
    const minDate = moment(data[0].date);
    const maxDate = moment(data[data.length - 1].date);
    return (
      <table className='reportTable'>
        <thead>
          <tr>
            <th width='auto'>Название</th>
            <th width='60px'>Цена</th>
            <th width='60px'>Кол-во</th>
            <th width='80px'>Сумма</th>
          </tr>
        </thead>
        <tbody>
          {data.map(this.renderDetailedDayPrice)}
          <tr className='reportTableTotal'>
            <td colSpan={3}>Итого за {minDate.format('DD.MM.YYYY')} - {maxDate.format('DD.MM.YYYY')}:</td>
            <td>{totalPrice}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderChunkInput = () => {
    const value = this.state.chunkSize;
    return (
      <div className='chunkInput'>
        <button
          className='chunkInputMinus'
          onClick={() => this.setState({
            chunkSize: Math.max(value - 1, 1)
          })}
        >-</button>
        <div className='chunkSize'>{value}</div>
        <button
          className='chunkInputPlus'
          onClick={() => this.setState({
            chunkSize: Math.min(value + 1, 5)
          })}
        >+</button>
      </div>
    )
  }

  render = () => {
    const { from, to, data, payments } = this.state;
    return (
      <div className='reportView'>
        <div className='reportTitle'>Статистика</div>
        <div className='reportSection'>
          <div className='reportName'>Интервал</div>
          <div className='dateRange'>
            <label>Дни с</label>
            <DateInput
              properties={{
                type: 'date'
              }}
              object={from}
              onChange={(k, value) => this.setState({from: value})}
            />
            <label>по</label>
            <DateInput
              properties={{
                type: 'date'
              }}
              object={to}
              onChange={(k, value) => this.setState({to: value})}
            />
          </div>
          <div className='intervalButtons'>
            <button className='outline' onClick={this.setLastMonth}>Пред. месяц</button>
            <button className='outline' onClick={this.setThisMonth}>Этот месяц</button>
            <button className='outline' onClick={this.setThisWeek}>Эта неделя</button>
            <button className='outline' onClick={this.setNextWeek}>След. неделя</button>
          </div>
          <button
            disabled={!from || !to}
            onClick={() => {
              this.requestStats();
              this.requestPayments();
            }}
          >Получить</button>
        </div>
        {data ? <>
          {data.length < 10 ?
            <div className='reportSection'>
              <div className='reportName'>Моторину</div>
              {this.renderMotorinExport(data)}
              <button
                className='secondary'
                onClick={this.blockOrders}
              >Заказ отправлен - Заблокировать</button>
            </div>
          : null}
          {data.length < 10 ?
            <div className='reportSection print'>
              <div className='reportName'>На холодильник</div>
              {/*<div className='reportSetting'>
                <label>Печать по:</label>
                {this.renderChunkInput()}
              </div>*/}
              {this.renderDailyMeals(data)}
            </div>
          : null}
          {data.length < 10 ?
            <div className='reportSection'>
              <div className='reportName'>Суммы по дням</div>
              {this.renderDailySums(data)}
            </div>
          : null}
          <div className='reportSection'>
            <div className='reportName'>Стоимость итоги</div>
            {this.renderSumarryCosts(data, payments)}
          </div>
          <div className='reportSection'>
            <div className='reportName'>Стоимость детализация</div>
            {this.renderDetailedPrice(data)}
          </div>
        </> : null}
      </div>
    )
  }
}

export default (withRouter(ReportView));
